import React, { Fragment } from 'react'

import HeaderDesignSystem from '../../components/molecules/HeaderDesignSystem'

const Animations = () => {
  return(
    <Fragment>
      <HeaderDesignSystem
        title="Animaciones"
      />
    </Fragment>
  )
}

export default Animations